export const getContrastColor = (hex: string) => {
    let [r, g, b] = [hex.slice(1, 3), hex.slice(3, 5), hex.slice(5, 7)].map(
        (hex) => parseInt(hex, 16)
    )
    let yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 128 ? '#FFFFFF' : '#000000'
}
